import Types from '../types';

const toggleSidebarHide = () => ({
  type: Types.TOGGLE_SIDEBAR_HIDE,
});

export default toggleSidebarHide;
